import { call, put, select, takeLatest } from 'redux-saga/effects'
import { handleApiError } from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import { getAuthenticationJwtSelector } from '../../login/selectors/getAuthenticationJwt.selector'
import { EKGImportConstants } from '../store/ekgImport.constants'
import { EKGImportService } from '../services/ekgImport.service'
import { setPowerOnTimeListResults } from '../store/ekgImport.actions'
import { IFetchPowerOnTimesResponse, IFetchPowerOnTimesRequest } from '../store/ekgImport.types'
import { getEKGImportSelector } from '../selectors'

export function* getPowerOnTimeListResults() {
  const authenticationJwt: string = yield select(getAuthenticationJwtSelector)
  const { filteredFrom, filteredMonitor } = yield select(getEKGImportSelector)

  try {
    const ekgImportService = new EKGImportService(authenticationJwt as string)

    const fetchPowerOnTimesRequest: IFetchPowerOnTimesRequest = {
      fromHours: filteredFrom?.hours,
      monitor: filteredMonitor?.monitorSerial,
    }

    const response: IFetchPowerOnTimesResponse = yield call(
      [ekgImportService, ekgImportService.fetchPowerOnTimes],
      fetchPowerOnTimesRequest
    )
    if (response.status === 200) {
      const powerOnTimeList = response.data.powerOnTimes

      yield put(setPowerOnTimeListResults(powerOnTimeList))
    } else {
      response.failure = true
      if (response.messages?.length) {
        const index = response.messages.findIndex((x) => x.status === response.status)
        response.responseMessage = response.messages[index].message
      } else {
        response.responseMessage =
          'There was an error processing your EKG import. Please contact customer support for further assistance.'
      }
      yield put(handleApiError(response))
    }
  } catch (e: any) {
    const cause = e.message ? e.message : 'unknown'
    const errorResponse = {
      status: null,
      messages: [
        {
          status: null,
          display: [
            { id: 3, name: 'Alert' },
            { id: 1, name: 'Log' },
          ],
          message: `An error occurred during EKG import. Cause: ${cause}`,
        },
      ],
    }
    yield put(handleApiError(errorResponse))
  }
}

export function* getPowerOnTimeListResultsSaga() {
  yield takeLatest([EKGImportConstants.GET_POWER_ON_TIME_LIST_RESULTS], getPowerOnTimeListResults)
}
